<template>
  <div class="calendar-layout">
    <div class="row row-gap-20 mb-20">
      <div class="col-lg-6 col-12">
        <default-box>
          <div class="d-flex align-items-center justify-content-between cursor_pointer"
               @click.stop="toggle.approved_vacation = !toggle.approved_vacation">
            <small-title no_margin :text="$t('vacations.approved_vacations')"/>
            <default-button button_smaller>
              <chevron-down-icon :rotate="toggle.approved_vacation"/>
            </default-button>
          </div>
          <slide-up-down :active="toggle.approved_vacation">
            <div class="mt-10">
              <div v-for="(approved, key) in approved_vacation"
                   class="row row-gap-5">
                <div class="col-6">
                  <b>{{$t('vacations.from')}}</b>: {{ approved.date_start }}
                </div>
                <div class="col-6">
                  <b>{{$t('vacations.to')}}</b>: {{ approved.date_end }}
                </div>
                <div
                  v-if="approved_vacation.length !== key+1"
                  class="col-12 border-bottom mb-5">
                </div>
              </div>
            </div>
          </slide-up-down>
        </default-box>
      </div>
      <div class="col-lg-6 col-12">
        <default-box>
          <div class="d-flex align-items-center justify-content-between cursor_pointer"
               @click.s.stop="toggle.on_validation = !toggle.on_validation">
            <small-title no_margin :text="$t('vacations.on_validation')"/>
            <default-button
              button_smaller>
              <chevron-down-icon :rotate="toggle.on_validation"/>
            </default-button>
          </div>
          <slide-up-down :active="toggle.on_validation">
            <div class="mt-10">
              <div v-for="(vacation, key) in pending_approving_vacation"
                   class="row row-gap-5">
                <div class="col-6">
                  <b>{{$t('vacations.from')}}</b>: {{ vacation.date_start }}
                </div>
                <div class="col-6">
                  <b>{{$t('vacations.to')}}</b>: {{ vacation.date_end }}
                </div>
                <div
                  v-if="pending_approving_vacation.length !== key+1"
                  class="col-12 border-bottom mb-5">
                </div>
              </div>
            </div>
          </slide-up-down>

        </default-box>
      </div>
      <div class="col-lg-6 col-12">
        <default-box>
          <div class="d-flex align-items-center justify-content-between cursor_pointer"
               @click="toggle.your_vacations = !toggle.your_vacations">
            <small-title no_margin :text="$t('vacations.your_vacations')"/>
            <default-button
              button_smaller>
              <chevron-down-icon :rotate="toggle.your_vacations"/>
            </default-button>
          </div>
          <slide-up-down :active="toggle.your_vacations">
            <div class="mt-10">
              <div class="mb-5"><b>{{$t('vacations.begin_of_calculating')}}</b>: {{ vacations_begin_of_calculating }}</div>
              <div class="mb-5"><b>{{$t('vacations.approved')}}</b>: {{ approved_vacation_qty }} days</div>
              <div class="mb-5"><b>{{$t('vacations.new')}}</b>: {{ get_vacation_dates.length }} days</div>
              <div class="mb-5"><b>{{$t('vacations.total_selected')}}</b>: {{ selected_vacation_dates }} days</div>
              <div class="mb-5"><b>{{$t('vacations.available')}}</b>: {{ max_vacation_available }} days</div>
            </div>
          </slide-up-down>
        </default-box>
      </div>
      <div class="col-lg-6 col-12">
        <default-box>
          <div class="d-flex align-items-center justify-content-between cursor_pointer"
               @click.stop="toggle.not_approved_vacation = !toggle.not_approved_vacation">
            <small-title no_margin :text="$t('vacations.rejected_by_some_reasons')"/>
            <default-button
              button_smaller>
              <chevron-down-icon :rotate="toggle.not_approved_vacation"/>
            </default-button>
          </div>
          <slide-up-down :active="toggle.not_approved_vacation">
            <div v-for="(vacation, key) in not_approved_vacation"
                 class="row row-gap-5 mt-10">
              <div class="col-6">
                <b>{{$t('vacations.from')}}</b>: {{ vacation.date_start }}
              </div>
              <div class="col-6">
                <b>{{$t('vacations.to')}}</b>: {{ vacation.date_end }}
              </div>
              <div
                v-if="not_approved_vacation.length !== key+1"
                class="col-12 border-bottom mb-5">
              </div>
            </div>
          </slide-up-down>
        </default-box>
      </div>
    </div>
    <div
      v-if="get_vacation_dates.length"
      class="sticky-top mb-20">
      <default-box class="d-flex align-items-center">
        <span><b>{{$t('vacations.total_selected')}}</b>: {{ selected_vacation_dates }} {{ $t('vacations.days') }}</span>
        <span class="ml-10"><b>{{$t('vacations.available')}}</b>: {{ max_vacation_available }} {{ $t('vacations.days') }}</span>
        <default-button
          button_small
          @click="saveMyVacations"
          :disabled="loading"
          class="ml-auto">
          {{$t('vacations.save_vacations')}}
        </default-button>
        <default-button
          button_small
          @click="sendToManager"
          :disabled="!vacation_dates_valid || loading"
          class="ml-15">
          {{$t('vacations.send_vacation_to_manager')}}
        </default-button>
      </default-box>
    </div>
    <default-box :loader="loading">
      <calendar
        is_multiple_choice
        show_two_in_column
        is_range_choice
        :selectable_weekend="Boolean(getUser.allow_weekend_vacation)"
        :disabled_dates="get_disabled_dates"
        :background_texts_by_date="get_holiday_dates_text"
        :selected_dates="get_vacation_dates"
        :calendar_date_outer.sync="current_year"
        :events="get_events"
        @selectedDays="selectedDays"
        @yearChange="fetchMyVacations()"
      />
    </default-box>
  </div>
</template>

<script>

import Calendar from "../small_components/calendar/Calendar";
import DefaultBox from "../slots/DefaultBox";
import {SORT_BY_DATE_ARRAY, unlinkVueVariable} from "../../helpers/global_vars";
import {axiosPublicHoliday, axiosUser} from "../../helpers/axios_requests";
import {getDateFormatShortDateStr} from "../../mixins/dateMixin";
import Loader from "../small_components/Loader";
import {mapActions, mapGetters} from "vuex";
import SmallTitle from "../small_components/SmallTitle";
import SlideUpDown from "../small_components/SlideUpDown";
import DefaultButton from "../small_components/DefaultButton";
import ChevronDownIcon from "../icons/ChevronDownIcon";
import {FORMAT_ERROR_MESSAGE} from "../../helpers/validation_error_message";
import {STATUS_ERROR} from "../../store/modules/notifiocation";

export default {
  name: 'MyVacationCalendarLayout',
  components: {
    ChevronDownIcon,
    DefaultButton,
    SlideUpDown,
    SmallTitle,
    Loader,
    DefaultBox,
    Calendar
  },
  computed: {
    ...mapGetters([
      'getUser'
    ]),
    get_vacation_dates() {
      return this.vacation_dates.map(el => el.date)
    },
    vacation_dates_valid() {
      return this.vacation_dates.every(el => el.id)
    },
    approved_vacation_qty() {
      return this.approved_vacation.reduce((a, b) => a + b.dates.length, 0)
    },
    selected_vacation_dates() {
      return this.vacation_dates.filter(el => el.approved || !el.approved && !el.send).length + this.approved_vacation_qty
    },
    get_disabled_dates() {
      return [
        ...this.get_holiday_dates,
        ...this.get_events_dates
      ]
    },
    get_holiday_dates() {
      return this.holiday_dates.map(el => el.date)
    },
    get_holiday_dates_text() {
      let data = {}
      this.holiday_dates.forEach(el => {
        data[el.date] = el.title
      })
      return data
    },
    max_vacation_available() {
      return this.getUser.available_vacation_days
    },
    get_events() {
      return [
        ...this.approved_vacation,
        ...this.not_approved_vacation,
        ...this.pending_approving_vacation,
      ]
    },
    get_events_dates() {
      if (!this.get_events.length) return []
      let dates = []
      this.get_events.forEach(event => {
        dates = dates.concat(event.dates)
      })
      return dates
    }
  },
  data() {
    return {
      loading: false,
      current_year: (new Date).getFullYear(),
      vacation_dates: [],
      approved_vacation: [],
      not_approved_vacation: [],
      pending_approving_vacation: [],
      holiday_dates: [],
      coworkers_vacations: [],
      vacations_begin_of_calculating: null,

      toggle: {
        approved_vacation: false,
        on_validation: false,
        your_vacations: false,
        not_approved_vacation: false,
      }
    }
  },
  mounted() {
    this.loading = true
    Promise.all([
      this.fetchHolidays(true),
      this.fetchMyVacations(true)
    ]).finally(() => {
      this.loading = false
    });
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    async fetchHolidays(promise = false) {
      if (!promise) {
        this.loading = true
      }
      await axiosPublicHoliday.fetchList({year: this.current_year})
        .then(({data}) => {
          this.holiday_dates = data.map(el => {
            el.date = getDateFormatShortDateStr(new Date(el.date))
            return el
          })
          return Promise.resolve(true)
        })
        .finally(() => {
          if (!promise) {
            this.loading = false
          }
        })
    },
    async fetchMyVacations(promise = false) {
      if (!promise) {
        this.loading = true
      }
      await axiosUser.getMyVacations({year: this.current_year})
        .then(({data}) => {
          this.vacation_dates = (data?.new_vacations || []).map(el => {
            el.date = getDateFormatShortDateStr(new Date(el.date))
            return el
          })
          this.approved_vacation = this.parseDaysGroups(
            data?.approved_vacation || [],
              this.$i18n.t('vacations.your_approved_vacation')
          )
          this.not_approved_vacation = this.parseDaysGroups(
            data?.not_approved_vacation || [],
              this.$i18n.t('vacations.not_approved_vacation')
          )
          this.pending_approving_vacation = this.parseDaysGroups(
            data?.pending_approving_vacation || [],
              this.$i18n.t('vacations.awaiting_to_approve')
          )
          this.vacations_begin_of_calculating = data.vacations_begin_of_calculating

          return Promise.resolve(true)
        })
        .finally(() => {
          if (!promise) {
            this.loading = false
          }
        })
    },
    saveMyVacations() {
      this.loading = true
      axiosUser.updateMyVacations({
        year: this.current_year,
        dates: this.get_vacation_dates,
      }).then(r => {
        if (r.data.errors) {
          let message = FORMAT_ERROR_MESSAGE(r.data.errors)
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
          return;
        }
        this.fetchMyVacations()
      }).catch(e => {
        let message = FORMAT_ERROR_MESSAGE([e.message])
        this.actionPushNotification(
            {message: message, status: STATUS_ERROR}
        )
        this.loading = false
      })
    },
    sendToManager() {
      this.loading = true
      axiosUser.sendToManager({year: this.current_year,})
        .then(r => {
          if (r.data.errors) {
            let message = FORMAT_ERROR_MESSAGE(r.data.errors)
            this.actionPushNotification(
                {message: message, status: STATUS_ERROR}
            )
            this.loading = false
            return;
          }
          this.fetchMyVacations()
        }).catch(e => {
          let message = FORMAT_ERROR_MESSAGE([e.message])
          this.actionPushNotification(
              {message: message, status: STATUS_ERROR}
          )
        this.loading = false
      })
    },
    selectedDays({dates, deselect_date = false}) {
      let vacation_dates = dates.map(date => {
        if (!this.get_vacation_dates.includes(date)) {
          return {
            id: 0,
            date: date,
            title: '',
            approved: null,
            send: 0,
          }
        }
        return this.vacation_dates.find(vacation_date => vacation_date.date === date)
      }).filter(Boolean)
      if (this.selected_vacation_dates >= this.max_vacation_available && !deselect_date) return
      this.$set(this, 'vacation_dates', unlinkVueVariable(SORT_BY_DATE_ARRAY(vacation_dates, 'date')))
    },
    parseDaysGroups(list, group_name) {
      if (!Array.isArray(list) || !list.length) []
      return list.map(el => {
        el.name = group_name
        el.date_start = getDateFormatShortDateStr(new Date(el.date_start))
        el.date_end = getDateFormatShortDateStr(new Date(el.date_end))
        el.dates = el.dates.map(date => getDateFormatShortDateStr(new Date(date)))
        return el
      })
    }
  }
}
</script>
